import React from 'react';

export const Footer = () => {
  return (
    <footer>
      <div className="footer-inner">
        <div>
          <div className="footer-brand">AIFirstCHRO.com</div>
          <div className="footer-tagline">The playbook your CFO wishes you already had.</div>
        </div>
        <div className="footer-links text-white">
         &#169;  Amit Srivastava. 2026
          <button className="footer-link-btn">Privacy</button>
        </div>
      </div>
    </footer>
  );
};
